// extracted by mini-css-extract-plugin
export default {"editWrapper":"FailureTypesCreateModal_editWrapper__xs-pj","editButton":"FailureTypesCreateModal_editButton__7Y+dW"};